import { Helmet } from 'react-helmet';
import styled from 'styled-components';

const Policy = ({active}) => {

  const links = {
    policy: 'Policy-MasterBets365-1.pdf',
    privacy: 'Policy-MasterBets365-2.pdf',
    autoexclusion: 'Autoexclusión.pdf',
    equidad: 'Equidad y RNG.pdf',
    conflictos: 'Resolución de Conflictos.pdf',
    cuentas: 'Cuentas, Pagos y Bonificaciones.pdf',
    responsable: 'Juego Responsable.pdf',
    terminos: 'Términos y Condiciones.pdf'
  };

  return (
    <>
      <Helmet>
				<title>MasterBets365 | Términos y condiciones</title>
        {/* Verificar por ambiguedad en app */}
        <link rel="canonical" href="https://masterbets365.com/terminos-y-condiciones"/>
				<meta name="description" content={'Haz clic aquí para obtener información detallada sobre los términos y condiciones para usar el sitio web de MasterBets365 y sus productos.'}></meta>
      </Helmet>
      <Container>
        <iframe title='pdf' src={`https://drive.google.com/viewerng/viewer?embedded=true&url=https://admin.masterbets365.com/masterbets/policy/${links[active]}&embedded=true`} width="100%" height="700px"></iframe>
      </Container>
    </>
  )
}

const Container = styled.div`
  @media screen and (max-width: 1024px) {
    margin-top: 4rem;
  }
`;

export default Policy